import { GetTranslationsDto } from '@modeso/types__aumico-lib-settings-be';
import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Action, MemoizedSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as settingsActions from '../actions/settings.actions';
import { ITranslationsState } from '../interfaces/translations-state.interface';

const adapter: EntityAdapter<GetTranslationsDto> = createEntityAdapter<GetTranslationsDto>({});

export const initialTranslationsState: ITranslationsState = adapter.getInitialState({
    translations: null,
    error: null,
});

export function createSelectors<T>(TranslationsStateSelector: MemoizedSelector<T, ITranslationsState>) {
    return {
        selectTranslations: createSelector(TranslationsStateSelector, (state) => state.translations),
        selectError: createSelector(TranslationsStateSelector, (state) => state.error),
    };
}

const privateTranslationsReducer = createReducer(
    initialTranslationsState,
    on(settingsActions.translationsActions.onGetTranslationsSuccess, (state, action) => ({
        ...state,
        translations: action.payload,
    })),
    on(settingsActions.translationsActions.onGetTranslationsFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),
);

export function translationsReducer(state: ITranslationsState | undefined, action: Action) {
    return privateTranslationsReducer(state, action);
}
